// Active snowfall owns the cloud/lighting response. Season and accumulated
// ground snow do not: a cleared winter day can still have bright sunshine.
const unit=value=>Math.max(0,Math.min(1,Number.isFinite(value)?value:0));
export function weatherLighting(state){
 const amount=unit((state.snow??0)/.32),overcast=amount*amount*(3-2*amount);
 // A covered sky supplies broad fill. Its residual directional light must not
 // retain a crisp solar silhouette after the visible sun has disappeared.
 return{overcast,direct:1-.90*overcast,diffuse:1+1.20*overcast,
  shadow:(1-overcast)**2,sunVisibility:(1-overcast)**2,warmth:1-.8*overcast,
  waterLight:1-.4*overcast,background:1-.16*overcast};
}

// A bounded, visual-only bank fades with the already-smoothed snowfall. It
// never consumes simulation randomness, displaces a draggable cloud, or owns
// rain/interaction state. IDs cannot collide with the positive user-cloud IDs.
const snowBank=Object.freeze([
 {id:-1,x:-3.65,y:5.10,z:-.35,size:1.30,phase:.4},
 {id:-2,x:0,y:5.14,z:-1.40,size:1.38,phase:2.3},
 {id:-3,x:3.65,y:5.10,z:-.75,size:1.30,phase:4.2},
].map(cloud=>Object.freeze({...cloud,overcast:true,moisture:.9,squeeze:0})));
export function weatherClouds(state){
 if(weatherLighting(state).overcast<.001)return state.clouds;
 return[...state.clouds,...snowBank.map(c=>({...c,seed:((state.seed??1945)^Math.imul(-c.id,0x45d9f3b))>>>0}))];
}
